import {useState} from 'react';

import {LabelCompatibleType} from 'ui-library/charting/Types';
import ImmutableSet from 'util/ImmutableSet';

export interface UseSeriesExcludedState {
  excludedSeries: ImmutableSet<LabelCompatibleType>;
  toggleExcludedSeries: (label: LabelCompatibleType) => void;
}

export default function useSeriesExcludedState(): UseSeriesExcludedState {
  const [excludedSeries, setExcludedSeries] = useState(new ImmutableSet<LabelCompatibleType>());
  const toggleExcludedSeries = (label: LabelCompatibleType): void => {
    if (excludedSeries.has(label)) {
      setExcludedSeries(excludedSeries.delete(label));
    } else {
      setExcludedSeries(excludedSeries.add(label));
    }
  };

  return {excludedSeries, toggleExcludedSeries};
}
